// Undo/redo over immutable document snapshots. Edits that carry the same `key` within
// `COALESCE_MS` (a slider drag, typing a font size) fold into one step; `external` entries
// (an AI revision, a reloaded version) are undoable steps too, labelled for the UI.
export const HISTORY_LIMIT = 100;
export const COALESCE_MS = 800;

export const createHistory = present => ({ past: [], present, future: [], key: null, at: 0, label: null });

export function commit(history, next, { key = null, label = null, now = Date.now() } = {}) {
  if (next === history.present) return history;
  const folds = key && key === history.key && now - history.at < COALESCE_MS && history.past.length > 0;
  const past = folds ? history.past : [...history.past, history.present].slice(-HISTORY_LIMIT);
  return { past, present: next, future: [], key, at: now, label };
}

export function undo(history) {
  if (!history.past.length) return history;
  const previous = history.past[history.past.length - 1];
  return { past: history.past.slice(0, -1), present: previous, future: [history.present, ...history.future], key: null, at: 0, label: 'undo' };
}

export function redo(history) {
  if (!history.future.length) return history;
  const [next, ...future] = history.future;
  return { past: [...history.past, history.present].slice(-HISTORY_LIMIT), present: next, future, key: null, at: 0, label: 'redo' };
}

export const canUndo = history => history.past.length > 0;
export const canRedo = history => history.future.length > 0;
